import type { MeResponse } from '@immo/api-contract';

/**
 * Human-readable name for the signed-in (or impersonated) member behind an
 * `/auth/me` payload: "First Last" when either name part is present, else the
 * e-mail as a fallback. Shared by the user menu and the impersonation banner so
 * both render the same label.
 */
export function formatDisplayName(me: MeResponse): string {
  const parts = [me.user.firstName, me.user.lastName].filter((p): p is string => p !== null && p.length > 0);

  return parts.length > 0 ? parts.join(' ') : me.user.email;
}
